import { executeDbTransforms, updateTOS } from "../../firestore/Functions/AdminFunctions";
import { LoggedInLayoutSelector } from "../../Layouts/LoggedInLayoutSelector";
import { VerifyAdmin } from "./VerifyAdmin";

export function AdminFunctions() {

    const handleExecuteDbTransforms = async () => {
        executeDbTransforms();
    }

    const handleUpdateTOS = async () => {
        updateTOS();
    }

    return (
        <LoggedInLayoutSelector>
            <VerifyAdmin />
            <div className='main-bg min-h-[90vh] flex flex-row'>
                <div className='flex h-full w-[80%] mx-[10%]'>
                    <h1 className="text-2xl font-bold">Executable Functions</h1>
                    <div className="flex flex-row w-full">
                        <div className="flex flex-col rounded-lg border-solid border-2 my-2 p-2 mx-6 border-gray-300 w-[280px]">
                            <h2 className="text" >This if for updating the backend to match current functionality</h2>
                            <button onClick={handleExecuteDbTransforms} className="primary-button">Execute Db Transforms</button>
                        </div>
                        <div className="flex flex-col rounded-lg border-solid border-2 my-2 p-2 mx-6 border-gray-300 w-[280px]">
                            <h2 className="text" >This if for updating the TOS </h2>
                            <button onClick={handleUpdateTOS} className="primary-button">updateTOS</button>
                        </div>
                    </div>
                </div>
            </div>
        </LoggedInLayoutSelector>
    );
}